var map = {
	"./de/slogan.png": "2Oso",
	"./en/slogan.png": "GEoR",
	"./es/slogan.png": "+ZT9",
	"./fr/slogan.png": "SJQV",
	"./ja/slogan.png": "A6XR",
	"./ko/slogan.png": "/CUn",
	"./pt/slogan.png": "rOXd",
	"./ru/slogan.png": "c59B",
	"./tc/slogan.png": "GsqA",
	"./th/slogan.png": "A1rZ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ykWB";